import React from 'react'

import { AiFillInstagram, AiFillGithub, AiFillTwitterCircle, AiFillLinkedin, AiFillPlayCircle } from 'react-icons/ai'
import { BsTelegram, BsTwitch, BsSnapchat } from 'react-icons/bs'
import { SiHashnode } from 'react-icons/si'
import { FaDev } from 'react-icons/fa'
import { IoLogoDiscord } from 'react-icons/io5'
import '../styles/Socials.css';

const Socials = () => {
  return (
    <div className='socials'>
      <h2>Find Me @ The Web</h2>
      <div className="social">
        <div className='insta'>
          <AiFillInstagram />
          <p>Instagram</p>
          <a href="https://www.instagram.com/kunal._.shah._.017" target='_blank' rel='noreferrer'>📸 Follow Me</a>
        </div>
        <div className='git'>
          <AiFillGithub />
          <p>Github</p>
          <a href="https://github.com/kunalshah017" target='_blank' rel='noreferrer'>🧠 Open Source</a>
        </div>
        <div className='twit'>
          <AiFillTwitterCircle />
          <p>Twitter</p>
          <a href="https://twitter.com/kunalshah017" target='_blank' rel='noreferrer'>🗣 chit chat</a>
        </div>
        <div className='link'>
          <AiFillLinkedin />
          <p>Linkedin</p>
          <a href="https://linkedin.com/in/kunalshah017" target='_blank' rel='noreferrer'>🤝 Let's Connect</a>
        </div>
        <div className='tel'>
          <BsTelegram />
          <p>Telegram</p>
          <a href="https://t.me/kunalshah017" target='_blank' rel='noreferrer'>📧 DM Me</a>
        </div>
        <div className='spotify'>
          <AiFillPlayCircle />
          <p>Spotify</p>
          <a href="https://open.spotify.com/user/31hgv3hncqa5p4qme3hi7ll7nyeu" target='_blank' rel='noreferrer'>🎧 vibe with me</a>
        </div>
        <div className='hashnode'>
          <SiHashnode />
          <p>Hashnode</p>
          <a href="https://hashnode.com/@kunalshah017" target='_blank' rel='noreferrer'>📝 Read My Blogs</a>
        </div>
        <div className='twitch'>
          <BsTwitch />
          <p>Twitch</p>
          <a href="https://www.twitch.tv/kunalshah017" target='_blank' rel='noreferrer'>🎮 Watch Me Code</a>
        </div>
        <div className='snap'>
          <BsSnapchat />
          <p>Snapchat</p>
          <a style={{ color: 'black' }} href="https://www.snapchat.com/add/kunalshah_017?share_id=5McFMMDkZDg&locale=en-IN" target='_blank' rel='noreferrer'>📸 Snaapss</a>
        </div>
        <div className='dev'>
          <FaDev />
          <p>Dev.to</p>
          <a style={{ color: 'white' }} href="https://dev.to/kunalshah017" target='_blank' rel='noreferrer'>🤓 Coding Blogs</a>
        </div>
        <div className='discord'>
          <IoLogoDiscord />
          <p>Discord</p>
          <a style={{ color: 'white' }} href="https://discord.gg/8QXZQ5Q" target='_blank' rel='noreferrer'>🗣 Join the chat</a>
        </div>
      </div>
    </div>
  )
}

export default Socials
